import * as moment from "moment";

export class CoCcertificates {
  id: string;
  peBastidor: string;
  tcSolicitud: string;
  peCreacion: string;
  peEntrega: string;
  esId: string;
  analista: string;
  comentarios: string;
  fechaRealizacion: string;

  static cocCertificateFromJson(obj: Object) {
    let tcertificado = obj["tipoReforma"]
      ? obj["tipoCertificado"] + " " + obj["tipoReforma"]
      : obj["tipoCertificado"];
    return new CoCcertificates(
      obj["solicitud"],
      obj["bastidor"],
      tcertificado,
      moment(obj["fechaCreacion"]).format("DD/MM/yyyy"),
      obj["peEntrega"],
      obj["estado"],
      obj["usuario"],
      obj["comentarios"],
      obj["fechaEstado"] ? moment(obj["fechaEstado"]).format("DD/MM/yyyy") : ""
    );
  }

  constructor(
    id: string,
    peBastidor: string,
    tcSolicitud: string,
    peCreacion: string,
    peEntrega: string,
    estadoId: string,
    usuario: string,
    comentarios: string,
    fechaRealizacion: string
  ) {
    this.id = id;
    this.peBastidor = peBastidor;
    this.tcSolicitud = tcSolicitud;
    this.peCreacion = peCreacion;
    this.peEntrega = peEntrega;
    this.esId = estadoId;
    this.analista = usuario;
    this.comentarios = comentarios;
    this.fechaRealizacion = fechaRealizacion;
  }
}
